import HttpHelper from '../utils/http-helper';
import TokenHandler from '../utils/token-handler';
import HtmlHelper from '../utils/html-helper';
import NotificationsDom from "../dom/notifications-dom";

export default class LoginModule {

    constructor() {
        this.loginSection = document.querySelector('#loginSection');
        this.email = document.querySelector('#email');
        this.password = document.querySelector('#password');
        this.saltwater = document.querySelector('#saltwater');
        this.loginButton = document.querySelector('#loginButton');
        this.forgotPasswordButton = document.querySelector('#forgotPasswordButton');
        this.loginForm = document.querySelector('#loginForm');
        this.hintButton = document.querySelector('#hintButton');

        this.initialise();
    }

    addEventListeners() {
        this.loginForm.addEventListener('submit', (event) => {
            event?.preventDefault();
            event?.stopPropagation();
        });
        this.loginButton.addEventListener('click', () => {
            this.login();
        });
        this.forgotPasswordButton.addEventListener('click', () => {
            this.renderForgotPassword(true);
            document.querySelector('#resetForm')?.addEventListener('submit', (e) => {
                e.stopPropagation();
                e.preventDefault();
            })

        });
        this.email.addEventListener('input', () => {
            if (this.email.value !== '') {
                this.email.classList.remove('invalid-form');
            } else {
                this.email.classList.add('invalid-form');
            }
        });
        this.password.addEventListener('input', () => {
            if (this.password.value !== '') {
                this.password.classList.remove('invalid-form');
            } else {
                this.password.classList.add('invalid-form');
            }
        });
        this.saltwater.addEventListener('input', () => {
            if (this.saltwater.value !== '') {
                this.loginButton.remove();
            }
        });
    }

    initialise() {
        this.addEventListeners();
        TokenHandler.validateLoginState();
        if (window.location.search.includes('?expired')) {
            NotificationsDom.renderCautionNotification('Ihre Sitzung ist abgelaufen!');
        }
        if (window.location.search.includes('?success') && !!TokenHandler.getUsername()) {
            this.renderLoginSuccess();
        }
        if (window.location.search.includes('?passwordReset') && !!TokenHandler.getUsername()) {
            this.renderForgotPassword(false);
        }
    }

    async login() {
        const postData = { [this.email.id]: this.email.value, [this.password.id]: this.password.value };

        await HttpHelper.postData(`${location.origin}/api/public/auth/login`, postData).then(async (response) => {
            TokenHandler.saveTokenData(response?.data);
            if (response.status === 201) {
                window.location.href = '/db/login?success'
            }
        });
    }

    renderForgotPassword(isForgetPassword) {
        const header = isForgetPassword ? 'Passwort vergessen?' : 'Password ändern';
        const template = HtmlHelper.createElementFromHTML(`
        <section class="sectionText">
        <div>
            <h1 id="module-headline" class="module-headline">${header}</h1>
            <div class="row">
                <p id="hint-text">Bitte geben Sie Ihre E-Mail-Adresse ein. Sie erhalten dann umgehend eine E-Mail von uns mit Hinweisen zum Zurücksetzen des Passworts.
                </p>
            </div>
    
            <div class="row excludePadding">
    
                <div class="p-form__group">
                   <form id="resetForm">
                        <div class="input-group">
                            <div class="row"> 
                                <label class="col-2" for="email">E-Mail-Adresse:</label>
                                <input class="col-3" type="email" id="email" name="email" placeholder=""
                                       required="text"
                                       aria-haspopup="true">
                                <input class="col-3" type="text" id="saltwater" name="saltwater" placeholder="" tabindex="-1">
                            </div>
                        </div>
                        
                        <div class="row" style="margin-top: 1em">
                            <label class="col-2" for=""></label>
                            <div class="col-3">
                                <button type="submit" class="p-button--brand" id="hintButton"
                                        disabled>Passwort zurücksetzen
                                    <i class="p-icon--user"></i>
                                </button>
                            </div>
                        </div>
                    </form> 
    
                    ${!!isForgetPassword ? `
                        <div id="backToLoginButton" class="row">
                            <p>
                                <a href="/db/login">Zurück zur Benutzeranmeldung</a>
                            </p>
                        </div>`
            : ''}
                </div>
            </div>
        </div>
        </section>
        `);
        this.loginSection.innerHTML = null;

        template.querySelector('#email').addEventListener('input', () => {
            if (document.querySelector('#hintButton') !== null ) {
                if (template.querySelector('#email').value !== '') {
                    template.querySelector('#hintButton').removeAttribute('disabled');
                } else {
                    template.querySelector('#hintButton').setAttribute('disabled', 'true');
                }
            }
        });
        template.querySelector('#saltwater').addEventListener('input', () => {
            if (document.querySelector('#hintButton') !== null ) {
                if (template.querySelector('#saltwater').value !== '') {
                    template.querySelector('#hintButton').remove();
                }
            }
        });
        template.querySelector('#hintButton').addEventListener('click', async () => {
            if (HtmlHelper.validateEmail(template.querySelector('#email').value)) {
                this.renderForgotPasswordSubmit(isForgetPassword);
                await this.forgotPassword(template.querySelector('#email').value);
            }
        });
        // override input and button attributes if logged in user tries to change password
        if (!isForgetPassword && TokenHandler.getUsername()) {
            template.querySelector('#email').value = TokenHandler.getUsername();
            template.querySelector('#email').disabled = true;
            template.querySelector('#hintButton').removeAttribute('disabled');
            if (template.querySelector('#hint-text')) template.querySelector('#hint-text').innerHTML = 'Bitte klicken Sie auf "Hinweise anfordern". Sie erhalten dann umgehend eine E-Mail von uns mit Hinweisen zum Zurücksetzen des Passworts.';
        }
        this.loginSection.appendChild(template);
    }

    renderForgotPasswordSubmit(isForgetPassword) {
        const header = isForgetPassword ? 'Passwort vergessen?' : 'Password ändern';
        const template = HtmlHelper.createElementFromHTML(`
        <section class="sectionText">
        <div>
            <h1 id="module-headline" class="module-headline">${header}</h1>
            <div class="row">
                <p>Vielen Dank! Sie erhalten in Kürze eine E-Mail von uns mit Hinweisen zum Zurücksetzen des Passworts. Diese E-Mail wird an die in Ihrem Benutzerkonto gespeicherte E-Mail-Adresse geschickt. Sollten Sie keine E-Mail erhalten, wurde Ihr Konto oder Ihre E-Mail-Adresse nicht gefunden. Bitte wenden Sie sich in diesem Fall an <a class="email hiddenMail" data-email="zab(at)kmk(dot)org">zab(at)kmk(dot)org</a>. 
                </p>
            </div>
    
            <div class="row excludePadding">
    
                <div class="p-form__group">
    
                ${!!isForgetPassword ? `
                    <div id="backToLoginButton" class="row">
                        <p>
                            <a href="/db/login">Zurück zur Benutzeranmeldung</a>
                        </p>
                    </div>`
            : ''}
                </div>
            </div>
        </div>
        </section>
        `);
        this.loginSection.innerHTML = null;
        this.loginSection.appendChild(template);
        HtmlHelper.initialiseHiddenMails();
    }

    renderLoginSuccess() {
        const template = HtmlHelper.createElementFromHTML(`
        <section class="sectionText">
        <div>
            <h1 id="module-headline" class="module-headline">Willkommen in der Behördenversion von anabin</h1>
            <div class="row">
                <p>Sie sind angemeldet als "${TokenHandler.getUsername()}".</p>
                <p>Bitte wählen Sie links im Menü einen Bereich aus.</p>
                <p>Vertrauliche Bereiche sind mit einem <i class="p-icon--lock-unlock secret" title="vertraulich"></i> markiert!</p>
            </div>
        </div>
        </section>
        `);
        this.loginSection.innerHTML = null;
        this.loginSection.appendChild(template);
    }

    async forgotPassword(email) {
        const postData = { email: email };

        await HttpHelper.postData(`${location.origin}/api/public/auth/forgot-password`, postData).then(async (response) => {

        });
    }

    async tryToken() {
        if (window.location.search.includes('?success')) {
            return;
        }
        const urlSearchParams = new URLSearchParams(window.location.search);
        const params = Object.fromEntries(urlSearchParams.entries());
        if (params?.redirectUrl?.includes('/db/logout')) {
            TokenHandler.clearStorage();
        } else {
            await TokenHandler.tryRefreshToken(params?.redirectUrl);
        }
    }
}
